import { NavLink } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import "../assets/styles/bottom-menu.css";

const navLinkClassNames = (isActive: boolean) =>
  classNames(
    {
      "[color:rgba(25,27,31,1)] link-active": isActive,
      "text-default link-inactive": !isActive,
    },
    "relative flex flex-col gap-2 hover:[color:rgba(25,27,31,1)] focus:[color:rgba(25,27,31,1)] w-1/5 text-center",
  );

const BottomMenu = () => (
  <div className="support-widget-v2 flex h-[76px] w-full items-center justify-evenly text-xs">
    <NavLink
      to="/"
      className={navLinkClassNames}
      isActive={(_match, location) => {
        const path = location.pathname;
        return (
          path === "/" ||
          path === "/report_bug_form" ||
          path.startsWith("/message_confirmation/")
        );
      }}
    >
      <Icon type="sw-home" size={20} />
      <span>{t("support_widget.bottom_menu.home")}</span>
    </NavLink>
    <NavLink to="/conversations" className={navLinkClassNames}>
      <Icon type="sw-conversations" size={20} />
      <span>{t("support_widget_v2.bottom_menu.conversations")}</span>
    </NavLink>
    <NavLink
      to="/help"
      className={navLinkClassNames}
      isActive={(_match, location) => {
        const path = location.pathname;
        return (
          path === "/help" ||
          path.startsWith("/spaces/") ||
          path === "/space_groups" ||
          path.startsWith("/posts/")
        );
      }}
    >
      <Icon type="sw-help" size={20} />
      <span>{t("support_widget.bottom_menu.help")}</span>
    </NavLink>
    <NavLink
      to="/explore"
      className={navLinkClassNames}
      isActive={(_match, location) => {
        const path = location.pathname;
        return (
          path === "/explore" || path === "/events" || path.startsWith("/news")
        );
      }}
    >
      <Icon type="sw-explore" size={20} />
      <span>{t("support_widget_v2.bottom_menu.explore")}</span>
    </NavLink>
  </div>
);

export default BottomMenu;
